module.exports = __webpack_public_path__ + "static/ani-testimonial-967ba11c022879a8fdf9cb77f906fd35.png";